/* eslint-disable */
export default {
  logging: 'Wordt gelogd...',
  logCall: 'Oproep loggen',
  editLog: 'Lijst bewerken',
  select: 'Selecteer een overeenkomende opname',
  OnHold: 'In de wacht',
  Ringing: 'Gaat over',
  CallConnected: 'Oproep verbonden',
  unknownUser: 'Onbekende gebruiker',
  unknownNumber: 'Anoniem',
  unavailable: 'Niet beschikbaar',
  viewDetails: 'Details weergeven',
  addEntity: 'Nieuwe maken',
  addLog: 'Lijst',
  text: 'Tekstbericht',
  call: 'Oproep',
  missedCall: 'Gemist',
  inboundCall: 'Inkomend',
  outboundCall: 'Uitgaand',
  answeredBy: 'Beantwoord door',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select a matching record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"missedCall"@#@ @source: @#@"Missed"@#@
// @key: @#@"inboundCall"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outboundCall"@#@ @source: @#@"Outbound"@#@
// @key: @#@"answeredBy"@#@ @source: @#@"Answered by"@#@
